<button mat-flat-button class="actions-button btn" [ngClass]="config.size || GenericButtonSize.Medium" [color]="config.color" [type]="config.type" [disabled]="disabled">
    <img *ngIf="config.icon" class="icon" [ngClass]="{'with-text': config.text}" src="/assets/images/icons/{{ config.icon }}.svg"/>
    <span *ngIf="config.text" class="text">{{ config.text | translate }}</span>
</button>
